import { createFileRoute, notFound } from "@tanstack/react-router";

import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import LandingNotFound from "@/components/landing/LandingNotFound";
import UseCaseCategoryPage from "./-components/UseCaseCategoryPage";
import { publishedCaseCards } from "@/content/landing/useCaseCards";
import { findCategory } from "./-components/useCaseCategoriesContent";

/**
 * The five category pages the home page's use-case panes link out to.
 *
 * The five pages' own copy is committed, since they are a route family rather
 * than a CMS collection, but the cards they list are the use-case pages'
 * own and come from the CMS with them. A slug the array does not carry answers
 * a real 404 rather than a soft one.
 */
export const Route = createFileRoute("/use-cases-categories/$slug")({
  loader: async ({ params }) => {
    const category = findCategory(params.slug);
    if (!category) {
      throw notFound();
    }
    return { category, cards: await publishedCaseCards() };
  },
  /** `loaderData` is absent exactly when the loader threw `notFound()`. */
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  component: UseCaseCategoryRoute,
  notFoundComponent: LandingNotFound,
});

function UseCaseCategoryRoute() {
  const { category, cards } = Route.useLoaderData();
  return <UseCaseCategoryPage category={category} cards={cards} />;
}
